<template>
    <b-container class="py-5 mb-5">
        <b-row>
            <b-col cols="12">
                <div class="d-flex justify-content-end mb-2">
                    <div class="d-flex">
                        <div class="d-flex align-items-center mr-3">
                            <b-badge class="bgray-300">에</b-badge>: 에코바디스,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['미']">미</b-badge>: 미신청,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['신']">신</b-badge>: 신청완료,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['답']">답</b-badge>: 답변중,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['평']">평</b-badge>: 평가중,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['보']">보</b-badge>: 보완중,
                        </div>
                        <div class="d-flex align-items-center mr-3">
                            <b-badge :variant="progress_bg['완']">완</b-badge>: 완료,
                        </div>
                        <div class="flex align-items-center">
                            <b-badge :variant="progress_bg['취']">취</b-badge>: 취소
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-table-simple hover class="sep-table">
                    <b-thead>
                        <b-tr>
                            <b-td>개수</b-td>
                            <b-td> 프로젝트 / 캠페인 </b-td>
                            <b-td>기업명</b-td>
                            <!-- <b-td>산업</b-td> -->
                            <b-td class="text-center" style="min-width: 90px;">평가유형</b-td>
                            <!-- <b-td v-for="stat in basic_status" :key="stat.id" class="text-center" style="min-width: 75px;">{{stat.txt}}</b-td> -->
                            <b-td v-for="stat in basic_status" :key="stat.id" class="text-center" style="min-width: 70px;">{{stat.txt}}</b-td>
                            <b-td v-if="is_admin >= 3" style="min-width: 110px;" class="text-center">기한</b-td>
                            <b-td v-if="is_admin >= 3" class="text-center">개선과제 관리</b-td>
                            <!-- <b-td v-if="is_admin >= 3" class="text-center" style="width: 100%;min-width: 90px;max-width: 90px;">담당자 이메일</b-td> -->
                            <b-td v-if="is_admin >= 3" class="text-center" style="min-width: 70px;">담당자 이메일</b-td>
                            <b-td v-if="is_admin >= 3" class="text-center">관리</b-td>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <template v-if="is_loaded_project_progress">
                            <b-tr v-if="!project_companies || !project_companies.length">
                                <b-td colspan="12" class="text-center gray-600 py-4">참여 기업이 없습니다.</b-td>
                            </b-tr>
                            <b-tr v-for="(company, idx) in project_companies"
                                :key="`project-${company.project_code}-priority-company-${company.id}-idx-${idx}`"
                                :class="[{ 'bgray-300': ((!company.priority && company.status_code === 'completed') || (company.priority && company.priority.status_code === 'completed')) }]"
                                >
                                <b-td :rowspan="1" class="align-middle">
                                    {{ idx + 1 }}
                                </b-td>

                                <!-- 프로젝트 / 캠페인 -->
                                <b-td>
                                    <template v-if="company.priority">
                                        <div>
                                            <b-badge variant="dark"> 대체 </b-badge>
                                            <span class="ml-1 f-95">{{ company.priority.project_code }}</span>
                                            <b-badge variant="emerging" class="ml-2"> {{ company.priority.campaign_id ?? $t('미할당') }} </b-badge>    
                                        </div>
                                    </template>
                                    <div>
                                        <span class="f-95">{{ company.project_code }}</span>
                                        <b-badge variant="emerging" class="ml-1"> {{ company.campaign_id ?? $t('미할당') }} </b-badge>
                                    </div>
                                </b-td>

                                <!-- 기업명 -->
                                <b-td>
                                    <template v-if="company.priority">
                                        <b-badge :variant="getProgressColor(company.priority)" class="mr-2">
                                            {{ getProgressStatus(company.priority) }}
                                        </b-badge>
                                        <b-badge variant="dark" class="mr-1"> 대체 </b-badge>
                                        {{ company.priority.company_name }}
                                        <b-badge variant="advance" class="ml-1"> {{ company.priority.company_id }} </b-badge>
                                    </template>
                                    <div>
                                        <template v-if="!company.priority">
                                            <b-badge :variant="getProgressColor(company)" class="mr-2">
                                                {{ getProgressStatus(company) }}
                                            </b-badge>
                                        </template>
                                        {{ company.company_name }}
                                        <b-badge variant="advance" class="ml-1">
                                            {{company.company_id}}
                                        </b-badge>
                                    </div>
                                </b-td>
                                
                                <!-- 평가유형 -->
                                <b-td class="text-center align-middle">
                                    <template v-if="(((company.priority && company.priority.service_type) || (company && company.service_type)))">
                                        <b-btn size="sm"
                                               
                                            :variant="(company.priority && company.priority.service_type === '일반') || (!company.priority && company.service_type === '일반') ? 'tealgray' : 'teal'"
                                            :disabled="isAssessmentTypeDisabled(company)"
                                            @click="updateServiceType(company, idx)"
                                            >
                                            <template v-if="is_service_types_updating === idx">
                                                <b-spinner style="width: 1.3rem;height: 1.3rem" />
                                            </template>
                                            <template v-else>
                                                {{ company.priority ? company.priority.service_type : company.service_type }}
                                                <div v-if="company.priority" class="f-80">(대체 상태)</div>
                                            </template>
                                        </b-btn>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </b-td>
                                
                                <!-- 신청일 -->
                                <template v-if="company.priority">
                                    <b-td v-for="status in basic_status" :key="status.id"
                                        class="f-85 fw-300"
                                        :class="[checkAndGetStyle(company.priority.status_code, status.txt, company.priority), 'align-middle']"
                                        >
                                        {{ company.priority[status.og] ? formatDate(company.priority[status.og], 'YY-MM-DD HH:mm') : '-' }}
                                    </b-td>
                                </template>
                                <template v-else>
                                    <b-td v-for="status in basic_status" :key="status.id"
                                        class="f-85 fw-300 align-middle"
                                        :class="checkAndGetStyle(company.status_code, status.txt, company)"
                                        >
                                        {{ company[status.og] ? formatDate(company[status.og], 'YY-MM-DD HH:mm') : '-' }}
                                    </b-td>
                                </template>

                                <!-- 기한 -->
                                <b-td v-if="is_admin >=3"
                                      class="f-85 fw-300 align-middle"
                                    :class="checkAndGetStyle(company.priority ? company.priority.status_code : company.status_code, '기한', company.priority ? company.priority : company)"
                                    >
                                    {{ formatDate(company.priority ? company.priority.duedate_ts : company.duedate_ts, 'YY-MM-DD HH:mm') || '-' }}

                                    <template v-if="is_admin == 4">
                                        <br />
                                        <b-form-datepicker
                                            :id="`period-extension-datepicker-${company.priority ? company.priority.company_id : company.company_id}`"
                                            v-model="updating_dueDate[company.priority ? company.priority.company_id : company.company_id].duedate"
                                            :title="`${company.priority ? company.priority.company_name : company.company_name} - 제출기한 연장일 선택`"
                                            size="sm"
                                            alt="기한 연장하기"
                                            class=""
                                            locale="KR"
                                            variant="dark-border"
                                            :reset-button="true"
                                            :close-button="true"
                                            :today-button="true"
                                            :reset-value="company.priority && (company.priority.duedate_ts != 'NaT' || company.priority.duedate_ts)
                                                ? company.priority.duedate_ts
                                                : (company.duedate_ts != 'NaT' || company.duedate_ts)
                                                    ? company.duedate_ts
                                                    : null
                                                "
                                            label-reset-button="초기화"
                                            label-close-button="설정"
                                            label-today-button="오늘"
                                            no-close-on-select
                                            button-only
                                            :disabled="(company.priority && company.priority.status_code !== 'in_progress' || company.status_code !== 'in_progress') || updating_dueDate[company.priority ? company.priority.company_id : company.company_id].isUpdating"
                                            @input="selectCompanyDueDate(company.priority ? company.priority.company_id : company.company_id, idx, !!company.priority, company.company_id)"
                                            >
                                            <template v-slot:button-content>
                                                <fa icon="calendar-alt" />
                                            </template>
                                        </b-form-datepicker>
                                        <b-btn :ref="`company-${company.priority ? company.priority.company_id : company.company_id}-period-extension-btn`"
                                            title="기한 연장하기"
                                            size="sm"
                                            class="ml-1"
                                            variant="dark-border"
                                            :disabled="
                                                updating_dueDate[company.priority ? company.priority.company_id : company.company_id].duedate === (company.priority ? company.priority.duedate_ts : company.duedate_ts)
                                                ||
                                                updating_dueDate[company.priority ? company.priority.company_id : company.company_id].isUpdating
                                            "
                                            @click="saveUpdatedPeriod(
                                                    company.priority ? company.priority.campaign_id : company.campaign_id,
                                                    company.priority ? company.priority.company_id : company.company_id,
                                                    idx, !!company.priority, company.company_id
                                                )"
                                            >
                                            <fa icon="save" />
                                        </b-btn>
                                    </template>
                                    
                                </b-td>
                                
                                <!-- 개선과제 관리 -->
                                <b-td v-if="is_admin >= 3"
                                      class="text-center align-middle"
                                >
                                    <div class="d-flex">
                                        <div :class="['d-flex flex-column align-items-center flex-fill px-1', { 'mr-1': ((!company.priority && company.manual_status !== 'eco_vadis') || (company.priority && company.priority.manual_status !== 'eco_vadis'))}]">
                                            <template v-if="((!company.priority && company.manual_status === 'eco_vadis') || (company.priority && company.priority.manual_status === 'eco_vadis'))">
                                                <div class="f-80 bgray-300 gray-600 rounded border flex-fill px-2 py-1 mx-4">
                                                    비해당 (에코바디스)
                                                </div>
                                            </template>
                                            <template v-else-if="company.campaign_id == null">
                                                <div class="f-80 bgray-300 gray-600 rounded border flex-fill px-2 py-1 mx-4">
                                                    비해당 (미신청기업)
                                                </div>
                                            </template>
                                            <template v-else-if="!company.priority">
                                                <template v-if="company.is_questionnaire_download_block">
                                                    <div class="bg-secondary text-light flex-grow-1 f-80 rounded-top border-right w-100 px-2 py-1">
                                                        외부전송
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div :class="[company.is_actionplan_audit_sended ? 'bg-success text-light' : 'bg-warning text-secondary', 'flex-grow-1 f-80 rounded-top border-bottom w-100 px-2 py-1']">
                                                        {{ company.is_actionplan_audit_sended ? '전송' : '미전송' }}
                                                    </div>
                                                </template>
                                                <div :class="[company.is_actionplan_company_sumbitted ? 'bg-success text-light' : 'bg-warning text-secondary', 'flex-grow-1 f-80 rounded-bottom w-100 px-2 py-1']">
                                                    {{ company.is_actionplan_company_sumbitted ? '제출' : '미제출' }}
                                                </div>
                                            </template>
                                            <template v-else>
                                                <template v-if="company.priority.is_questionnaire_download_block">
                                                    <div class="bg-secondary text-light flex-grow-1 f-80 rounded-top border-right w-100 px-2 py-1">
                                                        외부전송
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div :class="[company.priority.is_actionplan_audit_sended ? 'bg-success text-light' : 'bg-warning text-secondary', 'flex-grow-1 f-80 rounded-top border-bottom w-100 px-2 py-1']">
                                                        {{ company.priority.is_actionplan_audit_sended ? '전송' : '미전송' }}
                                                    </div>
                                                </template>
                                                <div :class="[company.priority.is_actionplan_company_sumbitted ? 'bg-success text-light' : 'bg-warning text-secondary', 'flex-grow-1 f-80 rounded-bottom w-100 px-2 py-1']">
                                                    {{ company.priority.is_actionplan_company_sumbitted ? '제출' : '미제출' }}
                                                </div>
                                            </template>
                                        </div>

                                        <template v-if="company.campaign_id && (((!company.priority && company.manual_status !== 'eco_vadis') || (company.priority && company.priority.manual_status !== 'eco_vadis')))">
                                            <b-btn size="sm" @click="showCompanyActionplan(company)">관리</b-btn>
                                        </template>
                                    </div>
                                </b-td>
                                
                                <!-- 담당자 이메일 -->
                                <template v-if="is_admin >= 3">
                                    <b-td class="text-wrap align-middle f-85" style="word-break: break-all;">
                                        {{ company.priority ? company.priority.requested_e_mail : company.requested_e_mail }}
                                    </b-td>
                                </template>
                                
                                <!-- 관리 -->
                                <template v-if="is_admin >= 3">
                                    <b-td class="align-middle">
                                        <b-dropdown size="sm" text="관리" right>
                                            <template v-if="is_admin == 4">
                                                <b-dropdown-item-btn @click.stop="openEmailModal(company.priority ? company.priority : company)">
                                                    이메일 전송
                                                    <fa icon="envelope"></fa>        
                                                </b-dropdown-item-btn>
                                            </template>
                                            
                                            <b-dropdown-item-btn @click.stop="openCommentModal(company.priority ? company.priority : company)">
                                                기업 커뮤니케이션
                                                <fa icon="comment-dots"></fa>    
                                            </b-dropdown-item-btn>
                                        </b-dropdown>
                                    </b-td>
                                </template> 
                            </b-tr>
                        </template>
                        <b-tr v-else-if="load_error">
                            <b-td colspan="12" class="p-0">
                                <PageEmptyComponent compact :error="load_error" @retry="fetchProjectProgress" />
                            </b-td>
                        </b-tr>
                        <template v-else>
                            <b-tr v-for="n in 4" :key="`project_code-skeleton-list-${n}`">
                                <b-td> <b-skeleton></b-skeleton> </b-td>
                                <b-td style="min-width:120px;"> <b-skeleton></b-skeleton> </b-td>
                                <b-td> <b-skeleton></b-skeleton> </b-td>
                                <b-td> <b-skeleton></b-skeleton> </b-td>
                                <b-td v-for="(item, index) in basic_status" :key="index">
                                    <b-skeleton></b-skeleton>
                                </b-td>
                                <b-td> <b-skeleton></b-skeleton></b-td>
                                <b-td> <b-skeleton></b-skeleton> </b-td>
                                <b-td> <b-skeleton></b-skeleton></b-td>
                                <b-td> <b-skeleton></b-skeleton> </b-td>
                            </b-tr>
                        </template>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-button v-if="is_admin === 4"
                    variant="dark-border"
                    class="ml-2"
                    :disabled="is_downloading === true"
                    @click="downloadRequestStatus"
                    >
                    <span v-if="is_downloading !== true">
                        평가 진행현황 다운로드 <fa icon="file-excel" class="ml-1"/>
                    </span>
                    <span v-else>
                        <b-spinner small></b-spinner> 파일을 준비하는 중... (최대 1분이 소요됩니다)
                    </span> 
                </b-button>
            </b-col>
        </b-row>
        <!-- <b-table-simple hover class="sep-table">
            <b-thead>
                <b-tr>
                    <b-td>개수</b-td>
                    <b-td>기업명</b-td>
                    <b-td>산업</b-td>
                    <b-td>평가유형</b-td>
                    <b-td v-for="stat in basic_status" :key="stat.id" class="text-center" style="width: 75px;">{{stat.txt}}</b-td>
                    <b-td v-if="is_admin >= 3" style="width: 110px;" class="text-center">기한</b-td>
                    <b-td v-if="is_admin >= 3" style="width: 100px;" class="text-center">개선과제 관리</b-td>
                    <b-td v-if="is_admin >= 3" style="width: 150px;" class="text-center">담당자 이메일</b-td>
                    <b-td v-if="is_admin >= 3" style="width: 70px;" class="text-center">관리</b-td>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-if="is_loaded_project_progress">
                    
                </template>
                <template v-else>
                    <b-tr v-for="n in 4" :key="`project_code-skeleton-list-${n}`">
                        <b-td> <b-skeleton></b-skeleton> </b-td>
                        <b-td style="min-width:120px;"> <b-skeleton></b-skeleton> </b-td>
                        <b-td> <b-skeleton></b-skeleton> </b-td>
                        <b-td> <b-skeleton></b-skeleton> </b-td>
                        <b-td v-for="(item, index) in basic_status" :key="index">
                            <b-skeleton></b-skeleton>
                        </b-td>
                        <b-td> <b-skeleton></b-skeleton></b-td>
                        <b-td> <b-skeleton></b-skeleton> </b-td>
                        <b-td> <b-skeleton></b-skeleton></b-td>
                        <b-td> <b-skeleton></b-skeleton> </b-td>
                    </b-tr>
                </template>
            </b-tbody>
        </b-table-simple> -->
        <b-modal id='progress-mgt-modal' hide-footer title="이메일 보내기" size="lg">
            <div class="d-flex mt-3 pb-1">
                <div class="f-95 mr-3">제목 </div>
                <div class="w-100">
                    <b-form-radio-group v-model="mail_purpose" :options="mail_purpose_options" class="mb-2" @change="inputTitle" />
                    <b-form-input v-model="mail_title" placeholder="이메일 제목" />
                </div>
            </div>
            <div class="d-flex mt-3 pb-1">
                <div class="f-95 mr-4">To.</div>
                <div class="w-100">
                    <b-form-radio-group v-model="mail_to" :options="mail_to_options" class="mb-2" @change="inputTitle" />
                    <b-form-input v-model="to_e_mail" placeholder="수신인"  class="d-inline w-50" /> / {{ to_company_name }}
                </div>
            </div>
            
            <div class="f-95 mt-3 pb-1">내용</div>
            <b-form-textarea v-model="mail_contents" rows="12" class="mb-3" placeholder="내용 작성" />
            <div class="mb-2 text-right">
                <b-button variant="blue" class="mr-2" :disabled="is_sending_email==true" @click="sendEmail">
                    <template v-if="is_sending_email==false">
                        보내기 <fa icon="paper-plane" class="ml-2"></fa>
                    </template>
                    <template v-else>
                        <b-spinner small />
                    </template>
                </b-button>
                <b-button :disabled="is_sending_email==true" @click="$bvModal.hide('progress-mgt-modal')"> 취소 </b-button>
            </div>
        </b-modal>

        <b-modal id='comment-modal' hide-footer title="기업 커뮤니케이션 로그" size="lg">
            <comm-log :comment_company="comment_company"></comm-log>
        </b-modal>

        <b-modal id="improvement-management-modal" title="개선계획 과제 관리" size="xl"
            body-bg-variant="white"
            hide-footer
            centered
            @hidden="managing_actionplan_company = null"
            >
            <ManagingActionPlan :actionplan_company="managing_actionplan_company"
                @update-actionplan="updateActionPlan"/>
        </b-modal>
        
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue';
import CommLog from '@shared_components/admin/components/managing/CommLog.vue';
import ManagingActionPlan from '@shared_components/admin/components/managing/ManagingActionPlan';
import AssessmentCommonMixin from '@shared_mixins/assessment.common.mixin.js';
import downloadFile from '@shared_mixins/downloadFile';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'ProjectProgress',
    components: {
        PageEmptyComponent,
        CommLog,
        ManagingActionPlan
    },
    mixins: [
        AssessmentCommonMixin,
        downloadFile
    ],
    data() {
        return {
            is_service_types_updating: null,
            is_loaded_project_progress: false,
            load_error: '',
            is_downloading: false,
            basic_status: [
                {og:'requested_ts', txt:'신청일'},
                {og:'in_progress_ts', txt:'답변시작'},
                {og:'in_assessment_ts', txt:'제출일'},
                {og:'completed_ts', txt:'배포일'},
            ],
            basic_types: ['일반', '심화'],
            mail_title:'',
            to_company_name: '',
            to_company_id: '',
            to_campaign_id: '',
            to_e_mail: '',
            mail_purpose: '',
            mail_purpose_options: [ {text:'보완요청', value: '보완요청'}, {text:'리마인드', value: '리마인드'}],
            mail_to: 'single',
            mail_to_options: [ {text:'담당자에게만', value: 'single'}, {text:'기업 소속 인원 전체에게', value:'all'}],
            mail_contents: '',
            is_sending_email: false,
            comment_company: null,
            updating_dueDate: {},
            managing_actionplan_company: null,
            project_companies: null
        };
    },
    computed:{
        ...mapState(['is_admin', 'user_id']),
        ...mapState('project_code',['is_project_codes_loaded','now_project']),
        ...mapState('questions',['subs', 'subs_loaded','answer_company' ] ),
        isAssessmentTypeDisabled() {
            return (company) => {
                return ((company.priority && (!!company.priority.manual_status || company.priority.status_code === 'completed')) 
                    || (company.priority && (!!company.manual_status || company.status_code === 'completed')))
                || this.is_admin <= 2;
            };  
        }
    },
    watch: {},
    async created () {
        await this.fetchProjectProgress();
    },
    beforeDestroy () {},
    methods:{
        async fetchProjectProgress () {
            this.is_loaded_project_progress = false;
            this.load_error = '';
            try {
                const project_code = this.$route.query.pc ?? this.$route.params.project_code;
                const _res_project_progress = await this.$axios.get(`/projects/${project_code}/progress`);
                this.project_companies = this.sortingCompanies(_res_project_progress.data);

                this.updating_dueDate = [...this.project_companies].reduce((updatingCompanyDueDate, { company_id, duedate_ts, priority }) => {
                    updatingCompanyDueDate[priority ? priority.company_id : company_id] = {
                        duedate: !priority && duedate_ts != 'NaT'
                            ?  duedate_ts
                            : priority && priority.duedate_ts != 'NaT'
                                ? priority.duedate_ts
                                : null,
                        isUpdating: false
                    };
                    return updatingCompanyDueDate;
                }, {});

                this.is_loaded_project_progress = true;
            } catch (error) {
                this.load_error = getErrorMessage(error, '진행현황을 불러오지 못했습니다.');
            }
        },
        ...mapMutations('questions',['reset_subs','update_answer_company']),
        ...mapMutations('score', ['update_temp_project_companies']),
        ...mapActions('project_code', ['progressSendEmail']),
        async updateServiceType (company, company_idx) {
            if(this.is_admin <= 2) {
                alert('평가유형 변경은 관리자만 가능합니다.');
                return;
            }
            try {
                this.is_service_types_updating = company_idx;
                let as_is_status = company.priority ? company.priority.service_type : company.service_type;
                let to_be_status = as_is_status == '일반' ? '심화' : '일반';
                let confirm_msg = company.priority ? `[대체평가, ${company.priority.project_code}]`: ''; 
                confirm_msg += `"${company.priority ? company.priority.company_name : company.company_name}"`;
                confirm_msg += `기업의 평가유형을 "${as_is_status}"에서 "${to_be_status}" 으로 변경하시겠습니까?`;

                let is_confirm_updating_service_type = confirm(confirm_msg);
                if (is_confirm_updating_service_type) {
                    const company_id = company.priority ? company.priority.company_id : company.company_id;
                    const campaign_id = company.priority ? company.priority.campaign_id : company.campaign_id;
                    const project_code = company.priority ? company.priority.project_code : company.project_code;

                    const res_update_service_type = await this.$axios.put('/assessments/service_type', {
                        company_id, campaign_id, project_code, service_type: to_be_status
                    });

                    const _warnings = res_update_service_type.data.warnings;
                    if (_warnings && _warnings.length) {
                        alert(_warnings.join('\n'));
                    }

                    let _company_record = Object.assign({}, { ...this.project_companies[company_idx] });
                    if (company.priority) {
                        _company_record['priority']['service_type'] = res_update_service_type.data.service_type;
                    } else {
                        _company_record['service_type'] = res_update_service_type.data.service_type;  
                    }

                    this.project_companies[company_idx] = _company_record;
                }
            } catch (error) {
                // 서버가 보낸 사유를 우선 표시, 없으면 일반 문구
                alert(getErrorMessage(error, '죄송합니다. 평가유형 변경도중 장애가 발생했습니다. 개발팀에 문의주세요.'));
            } finally {
                this.is_service_types_updating = null;
            }
        },
        async showCompanyActionplan (_company) {
            const _res_ap = await this.$axios.get('/actionplans', {
                params: { request_id: _company.priority ? _company.priority.request_id : _company.request_id }
            });

            let _managing_actionplan_company = _company.priority ? _company.priority : _company;
            this.managing_actionplan_company = {
                ..._managing_actionplan_company,
                action_plan: _res_ap.data
            };
            this.$bvModal.show('improvement-management-modal');
        },
        updateActionPlan (_action_plan) {
            this.$set(this.managing_actionplan_company, 'action_plan', _action_plan);
        },
        async downloadRequestStatus () {
            try {
                this.is_downloading = true;
                const response = await this.$axios.get('/request/excel/'+ this.now_project.project_code, {
                    responseType: 'blob'
                });
                this.downloadFileFromResponse(response, `${this.now_project.project_code}_전체기업_진행현황`);
            } catch (error) {
                console.log(error);
            } finally {
                this.is_downloading = false;
            }
        },
        selectCompanyDueDate (company_id, company_idx, is_priority, parent_company_id) {
            let saveButtonDisabledState = true;
            let originDueDate = !is_priority
                ? this.project_companies[company_idx].duedate_ts
                : this.project_companies[company_idx]['priority'].duedate_ts;

            originDueDate = originDueDate === 'NaT' ? null : originDueDate;
            const updatingDueDate = this.updating_dueDate[is_priority ? parent_company_id : company_id].duedate;

            if (!originDueDate && updatingDueDate) {
                saveButtonDisabledState = false;
            } else if (originDueDate && updatingDueDate) {
                saveButtonDisabledState = originDueDate.split(' ')[0] === updatingDueDate;
            } else {
                saveButtonDisabledState = true;
            }
            this.$refs[`company-${is_priority ? parent_company_id : company_id}-period-extension-btn`][0].disabled = saveButtonDisabledState; 
        },
        async saveUpdatedPeriod (campaign_id, company_id, target_company_idx, is_priority) {
            try {
                this.updating_dueDate[company_id].isUpdating = true;
                let new_duedate = new Date(this.updating_dueDate[company_id].duedate);
                const _formatted_new_duedate = [
                    new_duedate.getFullYear(),
                    new_duedate.getMonth() + 1 < 10 ? `0${new_duedate.getMonth() + 1}` : new_duedate.getMonth() + 1,
                    new_duedate.getDate() < 10 ? `0${new_duedate.getDate()}` : new_duedate.getDate()
                ];
                const [
                    formatted_new_duedate,
                    confirmed_duedate
                ] = [
                    `${_formatted_new_duedate.join('-')} 18:00:00`, // 2022-09-22 18:00:00
                    `${_formatted_new_duedate[0]}년 ${_formatted_new_duedate[1]}월 ${_formatted_new_duedate[2]}일 저녁 6:00`
                ];

                const confirmed_extend_period = confirm(`${this.project_companies[target_company_idx].company_name}의 제출기한을 ${confirmed_duedate} 까지 연장하시겠습니까?`);
                if (!confirmed_extend_period) {
                    this.updating_dueDate[company_id] = {
                        duedate: is_priority
                            ? this.project_companies[target_company_idx]['priority']['duedate_ts']
                            : this.project_companies[target_company_idx].duedate_ts,
                        isUpdating: false
                    };
                    return false;
                }
                
                const updatingData = {
                    period: this.now_project.period,
                    company_id: company_id ,
                    campaign_id: campaign_id ,
                    new_duedate: formatted_new_duedate,
                    user_id: this.user_id
                };
                const _updated_dueDate_response = await this.$axios.get('/extend_duedate', { params: updatingData });
                const updated_new_duedate = _updated_dueDate_response.data.new_duedate;
                if (is_priority) {
                    this.project_companies[target_company_idx]['priority'].duedate_ts = updated_new_duedate;
                } else {
                    
                    this.project_companies[target_company_idx].duedate_ts = updated_new_duedate;
                }

                this.updating_dueDate[company_id]['duedate'] = updated_new_duedate;
                const company_name = is_priority
                    ? this.project_companies[target_company_idx]['priority'].company_name
                    : this.project_companies[target_company_idx].company_name;
                alert(`${company_name}의 제출기한이 ${confirmed_duedate} 까지 연장되었습니다.`);
            } catch (error) {
                if (error.response.status === '401') {
                    alert(this.$t('다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.'));
                    await this.$store.dispatch('logout');
                    this.$router.push({name:'Login'});
                } else {
                    alert('죄송합니다. 기한 연장 도중 장애가 발생해 실패했습니다. 개발팀에 문의해주세요.');
                }
            } finally {
                this.updating_dueDate[company_id].isUpdating = false;
            }
        },
        // getProgressStatus(company){
        //     if(company.manual_status == 'eco_vadis') return '에'
        //     else if(company.status_code == 'completed') return '완'
        //     else if(company.status_code == 'in_assessment') return '평'
        //     else if(company.status_code == 'requested') return '신'
        //     else if(company.status_code =='in_progress' && (company.in_assessment_ts=='NaT'||company.in_assessment_ts=='')) return '답'            
        //     else if(company.status_code == 'in_reprogress') return '보' 
        //     else if(company.status_code =='in_progress' && company.in_assessment_ts!='NaT') return '보'
        //     // if(company.priority && !company.status_code) return '대체'
        //     else return null
        // },
        checkAndGetStyle (status, progress_txt, company) {
            if (status == 'completed') {
                return 'bgray-300';
            } else {
                if (progress_txt=='기한') return this.getUrgentStamp(company);
            }
        },
        getUrgentStamp (company) {
            company = company.priority ? company.priority : company;
            let left_days = 0;
            let past_days = 0;
            let txt_duedate = null;
            let txt_past = null;
            if (this.isIE === true) {
                txt_duedate = company.duedate_ts.replace('-', '/');
                txt_past = company.in_assessment_ts.replace('-', '/');
            } else {
                txt_duedate = company.duedate_ts;
                txt_past = company.in_assessment_ts;
            }
            let due_gap = new Date(txt_duedate).getTime() - new Date().getTime();
            left_days = Math.floor(due_gap / (1000 * 60 * 60 * 24)); // 남은 일수

            let past_gap = new Date().getTime() - new Date(txt_past).getTime();
            past_days = Math.floor(past_gap / (1000 * 60 * 60 * 24)); // 지난 일수
            
            if((company.status_code=='requested'||company.status_code=='in_progress')&& left_days < 0 ) {
                return 'red7 fw-500 bgray-300';
            }
            if((company.status_code=='requested'||company.status_code=='in_progress')&& left_days < 3 ) {
                return 'red fw-500 bg-red3';
            }
            if(company.status_code=='in_assessment' && past_days >= 3 ) {
                return 'red fw-500 bg-red3';
            }
        },
        badges(company){
            // console.log(company.status_code);
            if (company.status_code=='in_progress' && (company.in_assessment_ts=='NaT'||company.in_assessment_ts=='')) return 'blue-basic';
            else if (company.status_code=='in_assessment'||company.status_code=='in_reprogress') return 'red';
            else if (company.status_code=='in_progress' && company.in_assessment_ts!='NaT') return 'red';
            else if (company.status_code=='completed') return 'basic';
            else if (company.status_code=='canceled') return 'advance';
            else return 'advance';
        },
        openEmailModal(company){
            this.$bvModal.show('progress-mgt-modal');
            // 이전 기업에 쓰던 제목/내용/목적이 남아 다른 기업에 발송되지 않도록 초기화
            this.mail_purpose = '';
            this.mail_title = '';
            this.mail_contents = '';
            this.mail_to = 'single';
            this.to_company_name = company.company_name;
            this.to_campaign_id = company.campaign_id;
            this.to_company_id = company.company_id;
            this.to_e_mail = company.requested_e_mail;
        },
        openCommentModal(company){
            this.$bvModal.show('comment-modal');
            this.comment_company = company;
        },
        inputTitle(){
            if (this.mail_purpose == '보완요청'){ this.mail_title = `ESG 평가 답변 보완 요청 - ${this.to_company_name}`;}
            else if (this.mail_purpose == '리마인드'){ this.mail_title = `ESG 평가 리마인드 - ${this.to_company_name}`;}
        },
        async sendEmail () {
            if (this.formCheck()!=false){
                if (this.mail_to === 'all') {
                    const ok = await this.$showModal({
                        type: 'confirm', state: 'warning', title: '이메일 전송',
                        message: `${this.to_company_name} 소속 인원 전체에게 메일이 발송됩니다. 발송한 메일은 되돌릴 수 없습니다. 보내시겠습니까?`
                    });
                    if (!ok) return;
                }
                this.is_sending_email = true;
                try {
                    let result = await this.progressSendEmail({
                        company_id: this.to_company_id,
                        campaign_id: this.to_campaign_id,
                        e_mail: this.to_e_mail,
                        mail_to_option: this.mail_to,
                        title: this.mail_title,
                        contents: this.mail_contents
                    });
                    if(result.code!='success'){
                        this.$EventBus.$emit('toast-failure', '이메일 전송 실패', result.msg || '이메일을 보내지 못했습니다.');
                    } else {
                        this.$bvModal.hide('progress-mgt-modal');
                        this.$EventBus.$emit('toast-success', '이메일 전송 완료', result.msg);
                    }
                } catch (error) {
                    this.$EventBus.$emit('toast-failure', '이메일 전송 실패', getErrorMessage(error, '이메일을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.'));
                } finally {
                    this.is_sending_email = false;
                }
            }           
        },
        formCheck(){
            if (this.to_company_id==''||this.to_e_mail=='') { alert('이메일을 보낼 기업이 선택되지 않았습니다.'); 
                return false; }
            else if (this.mail_title=='') { alert('이메일 제목을 작성해 주세요'); 
                return false; }
            else if (this.mail_contents=='') { alert('이메일 내용을 작성해 주세요'); 
                return false; }
            else return true;            
        }
    }
};
</script>

<style>
/* .red-dot{
    position: relative;

}
.red-dot::after {
    position: absolute;
    right: 0;
    top: 10px;
    width: 6px;
    height: 6px;
    border-radius: 0.5rem;
    background-color: var(--red);
    z-index: 10;
} */
</style>
